import styled from 'styled-components';

export const TextTableClient = styled.div`
  font-size: 12px;
`;
